module.exports = __webpack_public_path__ + "1e09f38cc59a3ccc24cd2d7d745566ac.otf";